import { render } from "./CadastrarConstrucaoMaterial.vue?vue&type=template&id=29387c54"
import script from "./CadastrarConstrucaoMaterial.vue?vue&type=script&lang=js"
export * from "./CadastrarConstrucaoMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__